// extracted by mini-css-extract-plugin
export default {"dashbordTitleContainer":"profile_dashbordTitleContainer__uJE2G"};